export default "__VITE_ASSET__CUXWzneU__"